
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 122.88 69.4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.85 0h107.18c4.32 0 7.85 3.53 7.85 7.85v53.69c0 4.32-3.53 7.85-7.85 7.85H7.85C3.53 69.4 0 65.87 0 61.55V7.85C0 3.53 3.53 0 7.85 0zm36.37 14.59v39.37h-9.48l-5.63-17.9v17.9h-9.05V14.59h9.05l6.05 17.73V14.59h9.06zm4.34 0h18.06v7.86h-7.21v7.52h6.74v7.47h-6.74v8.66h7.95v7.86h-18.8V14.59zm62.62 0l-4.83 39.37H92.86c-1.21-6.05-2.31-12.94-3.29-20.67-.45 3.33-1.46 10.22-3.03 20.67H73.13l-4.85-39.37h10.53l1.14 13.75 1.1 13.29c.41-6.88 1.41-15.89 3-27.04h11.21c.13 1.17.52 5.5 1.15 13.01l1.22 14.98c.64-9.53 1.65-18.86 3.03-27.99h10.52z","fill-rule":"evenodd","clip-rule":"evenodd"}})])
          )
        }
      }
    